<template>
    <div class="input-color">
        <div class="input-color__wrap">
            <div
                    class="input-color__label"
                    :class="{
                        'input-color__label_error': errorMessages.length
                    }"
            >{{ $t(label) }}</div>
            <v-menu
                    bottom
                    offset-y
                    :close-on-content-click="false"
            >
                <template v-slot:activator="{on}">
                    <div
                            class="input-color__example"
                            :class="{
                                'input-color__example_error': errorMessages.length
                            }"
                            :style="{
                                'background-color': localValue
                            }"
                            v-on="on"
                    ></div>
                </template>
                <v-card>
                    <v-color-picker
                            :value="localValue"
                            @update:color="changeValue($event)"
                            hide-inputs
                    ></v-color-picker>
                </v-card>
            </v-menu>
        </div>
        <div
                v-if="errorMessages.length"
                class="input-color__error"
        >
            <div
                    v-for="(item, key) in errorMessages"
                    :key="key"
            >{{ item }}</div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            value: {type: String, default: null},
            label: {type: String, default: 'msg.color'},
            errorMessages: {type: Array, default: () => []}
        },
        data() {
            return {
                localValue: this.value
            }
        },
        watch: {
            value(v) {
                this.localValue = v;
            }
        },
        methods: {
            changeValue(v) {
                this.$emit('input', v.hexa);
            }
        }
    }
</script>

<style lang="scss">
    .input-color {


        .input-color__wrap {
            display: flex;
            align-items: center;
        }
        .input-color__label {
            font-size: 13px;

            &.input-color__label_error {
                color: #ff5252;
            }
        }
        .input-color__example {
            width: 45px;
            height: 30px;
            border: 1px solid #9e9e9e;
            cursor: pointer;
            margin-left: 10px;

            &:hover {
                border-color: #000;
            }
            &.input-color__example_error {
                border-color: #ff5252;
            }
        }
        .input-color__error {
            color: #ff5252;
            padding: 2px 10px 0 10px;
        }
    }
</style>